import { Helmet } from 'react-helmet-async'
import HomeTemplate from '../templates/HomeTemplate.jsx'
import DownloaderSEO from '../components/ui/DownloaderSEO.jsx'
import { PAGES, buildFAQSchema, buildHowToSchema } from '../utils/seo.js'
import { useLanguage } from '../context/LanguageContext.jsx'

const { title, description, canonical } = PAGES.instagram

const faqSchema = buildFAQSchema([
  { q: 'Can I download Instagram Reels as MP3 and MP4?', a: 'Yes! FastAudio downloads Instagram Reels and videos as MP3 audio (up to 320kbps) or MP4 video. Both formats are shown after you paste the URL.' },
  { q: 'What types of Instagram content can I download?', a: 'Public Instagram Reels, standard video posts, and IGTV videos are supported. Private profiles and Stories cannot be downloaded.' },
  { q: 'Why does my Instagram download fail?', a: 'Instagram requires login to access most content from server IPs. Only publicly accessible posts without a login can be downloaded.' },
  { q: 'Do I need an Instagram account?', a: 'No account is required to download publicly visible Instagram content.' },
  { q: 'Can I download Instagram Stories?', a: 'No — Stories expire after 24 hours and require login to view.' },
])

const howToSchema = buildHowToSchema('How to Download Instagram Reels as MP3 or MP4', [
  { title: 'Find the Instagram post', text: 'Open the Reel or video post on Instagram.' },
  { title: 'Copy the link', text: 'Tap ⋯ on the post and select Copy Link.' },
  { title: 'Paste into FastAudio', text: 'Paste the URL — the video info loads automatically.' },
  { title: 'Choose MP3 or MP4', text: 'Pick your format: MP3 audio or MP4 video quality.' },
  { title: 'Click Download', text: 'Hit ⚡ Download and save your file.' },
])

export default function InstagramDownloader() {
  const { t } = useLanguage()
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>
      <HomeTemplate
        provider="instagram"
        title={title}
        description={description}
        canonical={canonical}
        badge={t('instagramBadge')}
        heading={
          <>
            {t('instagramH1')}{' '}
            <span className="text-gradient">{t('instagramH2')}</span>
          </>
        }
        subheading={t('instagramSub')}
        placeholder={t('igPlaceholder')}
      >
        <DownloaderSEO provider="instagram" />
      </HomeTemplate>
    </>
  )
}
